import React from 'react';
import './addressTable.css';
import PropTypes from 'prop-types';

const SimpleTable = ({
  title,
  columns,
  data = [],
  emptyRows = 3,
  editable = false,
  onChange
}) => {
  const handleChange = (rowIndex, key, value) => {
    const newData = [...data];
    newData[rowIndex][key] = value;
    onChange && onChange(newData);
  };

  return (
    <div style={{ marginBottom: '30px' }}>
      <h5 style={{ fontWeight: 'bold', marginBottom: '15px' }}>
        {title}
      </h5>

      <table className="address-table">
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i}>{col.header}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.length > 0
            ? data.map((row, i) => (
                <tr key={i}>
                  {columns.map((col, j) => (
                    <td key={j}>
                      {editable ? (
                        <input
                          className="form-control form-control-sm"
                          value={row[col.accessor] || ''}
                          onChange={e =>
                            handleChange(i, col.accessor, e.target.value)
                          }
                        />
                      ) : (
                        row[col.accessor]
                      )}
                    </td>
                  ))}
                </tr>
              ))
            : [...Array(emptyRows)].map((_, i) => (
                <tr key={i}>
                  {columns.map((_, j) => (
                    <td key={j}>&nbsp;</td>
                  ))}
                </tr>
              ))}
        </tbody>
      </table>
    </div>
  );
};

SimpleTable.propTypes = {
  title: PropTypes.string,
  columns: PropTypes.array,
  data: PropTypes.array,
  emptyRows: PropTypes.number,
  editable: PropTypes.bool,
  onChange: PropTypes.func
};

export default SimpleTable;